import React from "react";
import "../../../styles/form.css";

/**
 * Componente de diálogo para exibir a lista completa de tribunais
 */
const TribunaisDialog = ({ open, onClose, tribunais }) => {
  if (!open) return null;

  const parseTribunais = (value) => {
    if (!value) return [];
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed;
    } catch (e) {
      // fallback: split por vírgula e limpar aspas/colchetes
    }
    return value
      .replace(/[\[\]"]/g, "")
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);
  };

  const lista = parseTribunais(tribunais);

  const getGrupoTribunal = (item) => {
    const prefixo3 = item.substring(0, 3).toUpperCase();
    if (prefixo3.startsWith("TJ"))
      return { key: "TJ", label: "Justiça Estadual" };
    if (prefixo3.startsWith("JF"))
      return { key: "JF", label: "Justiça Federal" };
    if (prefixo3 === "TRF")
      return { key: "TRF", label: "Justiça Federal - Superiores" };
    if (prefixo3 === "TRT") return { key: "TRT", label: "Justiça do Trabalho" };
    if (
      prefixo3 === "STF" ||
      prefixo3 === "STJ" ||
      prefixo3 === "TSE" ||
      prefixo3 === "TST"
    )
      return { key: "ST", label: "Tribunais Superiores" };
    return { key: prefixo3, label: "" };
  };

  const agruparPorPrefixo = (items) => {
    const grupos = [];
    let grupoAtual = [];
    let grupoAtualInfo = null;

    items.forEach((item) => {
      const info = getGrupoTribunal(item);
      if (grupoAtualInfo && info.key !== grupoAtualInfo.key) {
        grupos.push({ ...grupoAtualInfo, items: grupoAtual });
        grupoAtual = [];
      }
      grupoAtualInfo = info;
      grupoAtual.push(item);
    });

    if (grupoAtual.length > 0 && grupoAtualInfo) {
      grupos.push({ ...grupoAtualInfo, items: grupoAtual });
    }

    return grupos;
  };

  const grupos = agruparPorPrefixo(lista);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content tribunais-dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <h3>Lista Completa de Tribunais</h3>
        <div className="tribunais-dialog-content">
          {grupos.length > 0 ? (
            <div className="tribunais-grupos">
              {grupos.map((grupo, gIndex) => (
                <div key={gIndex} className="tribunais-grupo">
                  <span className="tribunais-grupo-label">
                    <strong>
                      {grupo.label && (
                        <span className="tribunais-grupo-desc">
                          {grupo.label}
                        </span>
                      )}
                    </strong>
                  </span>
                  <div className="tribunais-grupo-items">
                    {grupo.items.map((tribunal, index) => (
                      <span
                        key={index}
                        className="tribunal-item"
                        style={{ marginRight: "6px", marginBottom: "4px" }}
                      >
                        {tribunal}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="no-data">Nenhum tribunal selecionado</p>
          )}
        </div>
        <div className="modal-actions">
          <button className="cancel-nome-btn" onClick={onClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export default TribunaisDialog;
